import Head from 'next/head';

export interface ICommonHead {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalLink?: string;
}

const CommonHead = ({
  canonicalLink,
  keywords = 'DJI社区,大疆社区,无人机玩家交流,大疆教程,手持设备玩家交流,无人机玩法,无人机教程,DJI,DJI Mavic,DJI Mini,DJI Air,Osmo Action,Osmo Pocket,DJI Avata,DJI Neo,DJI Flip',
  title = 'DJI大疆社区',
  description = '大疆社区官方论坛是无人机爱好者的大本营，在这里交流大疆无人机的使用技巧心得，了解大疆最新动态，参与大疆无人机活动互动，为大疆粉丝和无人机爱好者打造一个良好的互动交流平台。',
}: ICommonHead) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="keywords" content={keywords} />
      <meta name="description" content={description} />
      {canonicalLink && <link rel="canonical" href={canonicalLink} />}
    </Head>
  );
};

export default CommonHead;
